 import { Header } from "@/components/Header";
 import { Footer } from "@/components/Footer";
 import { SEO } from "@/components/SEO";
 import { Button } from "@/components/ui/button";
 import { Card, CardContent } from "@/components/ui/card";
 import { Users, Heart, MessageCircle, Calendar, ArrowRight, Video, Shield, Sparkles } from "lucide-react";
 import { Link } from "react-router-dom";
 
 const features = [
   { icon: Users, title: "프라이빗 스터디룸", description: "친구들만을 위한 개인 스터디룸을 만들어 함께 공부하세요." },
   { icon: Video, title: "화상 통화", description: "카메라를 켜고 서로의 존재를 느끼며 집중력을 높이세요." },
   { icon: MessageCircle, title: "실시간 채팅", description: "공부하면서 메시지를 주고받고, 질문하고 도움을 받으세요." },
   { icon: Calendar, title: "스터디 일정", description: "정기적인 스터디 세션을 예약하고 알림을 받으세요." },
   { icon: Shield, title: "안전한 환경", description: "초대한 친구들만 참여할 수 있는 안전한 공간입니다." },
   { icon: Heart, title: "동기부여", description: "친구들과 함께하면 더 오래, 더 집중해서 공부할 수 있습니다." },
 ];
 
 export default function StudyWithFriendsKr() {
   return (
     <div className="min-h-screen bg-background">
       <SEO 
         title="친구와 공부하기 | CSW | Online Workspace | Productivity Tool | Study Stream"
         description="친구들과 함께 온라인 스터디룸에서 공부하세요. 프라이빗 화상 통화, 실시간 채팅, 스터디 일정 관리 기능을 제공합니다."
         keywords="친구와 공부하기, 온라인 스터디, 프라이빗 스터디룸, 화상 스터디, 스터디 그룹"
         canonicalUrl="/kr/study-with-friends/"
       />
       <Header />
       
       <main>
         <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
           <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted" />
           <div className="absolute top-20 left-20 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-glow-pulse" />
           
           <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
             <div className="max-w-4xl mx-auto text-center space-y-8">
               <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight">
                 <span className="text-gradient">친구와 공부하기</span>
               </h1>
               <p className="text-xl sm:text-2xl text-muted-foreground font-light max-w-xl mx-auto">
                 친한 친구들과 함께 프라이빗 스터디룸에서 집중하세요.
               </p>
               <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg" asChild>
                 <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                   스터디룸 만들기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                 </a>
               </Button>
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="container mx-auto max-w-6xl">
             <div className="text-center mb-16">
               <h2 className="text-4xl md:text-5xl font-bold font-display mb-6">
                 <span className="text-gradient">친구</span>와 함께하는 장점
               </h2>
             </div>
             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
               {features.map((feature) => {
                 const Icon = feature.icon;
                 return (
                   <Card key={feature.title} className="group bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-all hover:scale-105">
                     <CardContent className="p-8 space-y-4">
                       <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                         <Icon className="w-6 h-6 text-primary" />
                       </div>
                       <h3 className="text-xl font-semibold text-foreground font-display">{feature.title}</h3>
                       <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                     </CardContent>
                   </Card>
                 );
               })}
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="max-w-4xl mx-auto text-center">
             <h2 className="text-4xl md:text-5xl font-bold mb-6 font-display">
               지금 <span className="text-gradient">친구들을 초대</span>하세요
             </h2>
             <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-10 py-7 text-lg" asChild>
               <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                 무료로 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
               </a>
             </Button>
           </div>
         </section>
       </main>
       
       <Footer />
     </div>
   );
 }